import React from 'react'
import PropTypes from 'prop-types'

import Moment from 'moment'

import SendButtonActive from '../SendButtonActive'

const Item = props => (
  <tr>
    <td> {parseInt(props.skip, 0) + props.indexKey + 1} </td>
    <td> {Moment(`${props.row.user.createdAt}`).format('MMMM, DD YYYY')} </td>
    <td> <span className="capitalize">{props.row.user.country.name}</span> </td>
    <td> <span className="capitalize">{props.row.user.firstName} </span></td>
    <td> <span className="capitalize">{props.row.user.lastName} </span></td>
    <td> {props.row.user.email} </td>
    <td> {props.row.user.hasAgreedTnc ? 'Yes' : 'No'} </td>
    <td> {props.row.user.verified ? 'Yes' : 'No'} </td>
    <td> {props.row.user.legacy ? 'Legacy' : 'Default'} </td>
    <td>
      {!props.row.user.verified ? <SendButtonActive email={props.row.user.email} /> : '-' }
    </td>
  </tr>
)

Item.defaultProps = {
  row: {
    id: '',
    createdAt: '',
    firstName: '',
    lastName: '',
    email: '',
  },
  skip: 0,
  indexKey: 0,
}

Item.defaultProps = {
  row: {
    hasAgreedTnc: false,
    verified: false,
  },
}

Item.propTypes = {
  row: PropTypes.shape({
    user: PropTypes.shape({
      id: PropTypes.string.isRequired,
      createdAt: PropTypes.string.isRequired,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      email: PropTypes.string,
      legacy: PropTypes.bool.isRequired,
      hasAgreedTnc: PropTypes.bool,
      verified: PropTypes.bool,
      country: PropTypes.shape({
        name: PropTypes.string,
      }).isRequired,
    }).isRequired,
  }).isRequired,
  skip: PropTypes.number.isRequired,
  indexKey: PropTypes.number.isRequired,
}

export default Item
